import { render, staticRenderFns } from "./SegmentList.vue?vue&type=template&id=f7c68e3a&scoped=true&"
import script from "./SegmentList.vue?vue&type=script&lang=js&"
export * from "./SegmentList.vue?vue&type=script&lang=js&"
import style0 from "./SegmentList.vue?vue&type=style&index=0&id=f7c68e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c68e3a",
  null
  
)

export default component.exports